import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import * as React from 'react';
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    return (_jsx("input", { type: type, className: clsx('flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm', 'placeholder:text-gray-400', 'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent', 'disabled:cursor-not-allowed disabled:opacity-50', className), ref: ref, ...props }));
});
Input.displayName = 'Input';
export { Input };
